export const EXPIRE_TOKEN = 'EXPIRE_TOKEN';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const SET_AUTO_EXPIRED_TOKEN = 'SET_AUTO_EXPIRED_TOKEN';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CANCEL_WAIT_LOGIN = 'CANCEL_WAIT_LOGIN';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE';
export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const REMOVE_DOCUMENT_TITLE = 'REMOVE_DOCUMENT_TITLE';
export const RESET_ACCESSES = 'RESET_ACCESSES';
export const SAVE_DOCUMENT_TITLE = 'SAVE_DOCUMENT_TITLE';
export const SET_LOGIN_METHOD = 'SET_LOGIN_METHOD';
export const SET_REQUIRE_PASSWORD_CHANGE = 'SET_REQUIRE_PASSWORD_CHANGE';
export const SET_SIGN_OFF_DIALOG_VISIBILITY = 'SET_SIGN_OFF_DIALOG_VISIBILITY';
export const SET_SSO_LOGIN_FAILURE = 'SET_SSO_LOGIN_FAILURE';
export const SET_TOKEN_STATUS = 'SET_TOKEN_STATUS';
export const SHOW_IDP_VIEW = 'SHOW_IDP_VIEW';
export const UPDATE_LOGON_USER = 'UPDATE_LOGON_USER';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
export const REGISTRATION_REQUEST = 'REGISTRATION_REQUEST';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const SET_LOCALES = 'SET_LOCALES';
export const SET_TIMEZONES = 'SET_TIMEZONES';
export const SET_ARCHIVE_WARNING_SHOWN = 'SET_ARCHIVE_WARNING_SHOWN';
